import styled from 'styled-components';

export const SearchWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
